import {PropsWithChildren, useEffect} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Backdrop from "@mui/material/Backdrop";
import {useTheme} from "@mui/material";
interface Props extends PropsWithChildren {
    symbols?:string;
    symbolText?: number | string;
    changeColor?:boolean;
  }
export default function MonySymbolsComponets(props:Props) {
   function changeMonySymbol(){
    switch (props.symbols) {
        case 'EUR':
            return '€'
            break;
    
        default:
            break;
    }
}
  
  return (
     <><span style={{color: props.changeColor ? "": "#18305B",fontWeight:'500'}}>{changeMonySymbol()}&nbsp; {props.symbolText}</span></>
  );
}